import script from "./CreateEditDeath.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateEditDeath.vue?vue&type=script&setup=true&lang=ts"

import "./CreateEditDeath.vue?vue&type=style&index=0&id=14c97f23&scoped=true&lang=css"

import exportComponent from "../../../../../../ss/MO/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c97f23"]])

export default __exports__